<template>
    <div>
        <div class="about_us_bg iden_bg">
            <div class="w_1200 w_1200_boot w_1200_boot_padding change_padding">
                <div class="contract_box">
                    <h1 class="title">合同鉴真</h1>
                    <div class="contract_test">
                        <p>
                            验证你持有的文档（PDF文件）是否为通过大众签章平台签署完成的文档<br/> 验证你持有的文档（PDF文件）有无被篡改
                        </p>
                    </div>
                    <div class="upload_doctype">
                        <div class="upload_doctype_top clearfix">
                            <div class="upload_doc_top_right">
                                <span>
                                  <span id="upload_doc_top_right" @click="handleOpenFile()">
                                      上传PDF文件
                                  </span>

                                    <img src="@/assets/img/up_img1.png" alt="">
                                </span>
                            </div>
                            <input
                                    :id="id"
                                    type="file"
                                    style="display: none"
                                    accept=".pdf"
                                    name="single"
                                    :data="{key:2}"
                                    @change="onChange($event,'id')"

                            />
                        </div>
                        <div class="upload_doctype_btm clearfix">
                            <p class="tips">
                                上传文件不显示？<br/>
                                注意检查一下文档格式哦！
                            </p>
                            <el-button id="verification" :disabled = 'disabled' class="test forbidden" :class="disabled?'hei':''" @click="verification">
                                开始验证&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;→
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="commenFooter"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "contractIden",
        data(){
            return{
                id: 'cropper-input-' +new Date(),
                disabled:true,
                contracturi:''
            }
        },
        methods:{
            onChange(e){
                var file = e.target.files[0]
                var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
                const extension = testmsg === 'pdf'
                const extension2 = testmsg === 'PDF'
                if(!extension && !extension2) {
                    this.$message({
                        message: '请上传.pdf格式的文件',
                        type: 'warning'
                    });
                    this.loading =false
                    return false;
                }

                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    this.$message({
                        message: '上传文件不能超过 10MB!',
                        type: "warning"
                    });
                    this.loading =false
                    return false;
                }
                var data = new FormData();
                data.append("file", file)
                data.append("project", 'menhu')
                data.append("business", 'public')
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/file/add/osFileUpload",
                    data:data,
                    succFun: res => {

                        if(res.code == 10000){
                            this.contracturi = res.data.id
                            this.disabled = false
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                        }else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }

                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
                return extension || extension2 && isLt2M
            },
            // 打开文件
            handleOpenFile() {
                const input = document.getElementById(this.id)
                input.addEventListener(
                    'click',
                    function() {
                        this.value = ''
                    },
                    false
                )
                input.click()
            },
            verification(){
                this.$router.push({ name: 'contractIdenResult', params: { contracturi:this.contracturi} });
            }
        }
    }
</script>

<style scoped>
.hei{
    background: #d6cabf;
}
.iden_bg{
    background:url(~@/assets/img/banner/iden_bg.png) no-repeat;
    background-size: 100% 150%;
}

</style>